import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./axiosInstance";


export const orderUser = createAsyncThunk('order/orderUser',
    async ({page,limit},{rejectWithValue}) => {
        try {
            const response = await axiosInstance.get(`/user/orders?page=${page}&limit=${limit}`);
            return response.data;
        }
        catch (error){
           return rejectWithValue(error.response.data.errors || [error.response.data.error])
        }
    }
)
export const fetchOrderByID = createAsyncThunk('order/fetchOrderByID',
    async (id,{rejectWithValue}) => {
        try {
            const response = await axiosInstance.get(`/user/orders/${id}`);
            return response.data;
        }
        catch (error){
           return rejectWithValue(error.response.data.errors || [error.response.data.error])
        }
    }
)

